import { render, staticRenderFns } from "./EmployeeHistorySalaryForm.vue?vue&type=template&id=afc87656&scoped=true"
import script from "./EmployeeHistorySalaryForm.vue?vue&type=script&lang=js"
export * from "./EmployeeHistorySalaryForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeHistorySalaryForm.vue?vue&type=style&index=0&id=afc87656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc87656",
  null
  
)

export default component.exports